// @ts-nocheck
const capitalizeWords = (string: string) => {
    return string
        .toLowerCase()
        .split(" ")
        .map(word => word[0].toUpperCase() + word.substring(1))
        .join(" ");
};

export default capitalizeWords;
